import '../node_modules/jquery-color-animation/jquery.animate-colors-min';
import './custom.scss';
import './index.scss';

import { SnackbarProvider } from 'notistack';
import React, { lazy, Suspense } from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Loading from 'shared/controls/loading';

import store from './redux/store';
import * as serviceWorker from './serviceWorker';

import TagManager from 'react-gtm-module';
import { gtmID } from './environments/env';

const tagManagerArgs = {
  gtmId: gtmID
};

TagManager.initialize(tagManagerArgs);

const CallbackPage = lazy(() => import('auth/pages/callback.page'));
const Dashboard = lazy(() => import('pages/dashboard/dashboard'));

ReactDOM.render(
  <BrowserRouter basename={'/'}>
    <Provider store={store as any}>
      <SnackbarProvider maxSnack={1} preventDuplicate>
        <Suspense fallback={<Loading />}>
          <Switch>
            <Route exact path='/callback' component={CallbackPage} />
            <Route exact path='/' component={Dashboard} />
            <Route path='/:cityCode' component={Dashboard} />
          </Switch>
        </Suspense>
      </SnackbarProvider>
    </Provider>
  </BrowserRouter>,
  document.getElementById('root')
);

serviceWorker.unregister();
